import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormGroup, FormControl, FormControlLabel, FormLabel, Checkbox, TextField, Grid, RadioGroup, Radio } from '@material-ui/core';
const useStyles = makeStyles({
    GridRoot: {
        minWidth: 56
    },
    FormControlRoot: {
        marginBottom: 20,
        '& .MuiTextField-root, & .MuiGrid-container': {
            marginTop: 10,
            '& textarea': {
                minWidth: 700
            }
        }
    },
    FormLabelRoot: {
        fontWeight: 'bold'
    },
    WalkOver: {
        paddingLeft: 10,
        paddingTop: 10
    }
});
export const EditMatchResultMiscSettings = props => {
    const classes = useStyles();
    const [liveScoreCode, setLiveScoreCode] = React.useState(props.matchData.liveScoreCode);
    React.useEffect(() => {
        if (!props.matchData.liveScore && props.matchData.liveScoreCode.trim().length === 0) {
            const max = 9999;
            const rand = Math.floor((Math.random() * max) + 1);
            setLiveScoreCode(rand.toString().padStart(4, '0'));
        }
        else {
            setLiveScoreCode(props.matchData.liveScoreCode);
        }
    }, [props.matchData.liveScoreCode]);
    const handleChange = (evt, newVal) => {
        console.log(evt);
        console.log(newVal);
    };
    const getError = (key) => {
        return props.errors && props.errors[key];
    };
    return (React.createElement(FormControl, { component: "fieldset", classes: { root: classes.FormControlRoot } },
        React.createElement(FormLabel, { component: "legend", classes: { root: classes.FormLabelRoot }, className: "printHide" }, "Indberet"),
        React.createElement(FormGroup, null,
            props.resultsForMatchClosed !== undefined &&
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: props.matchData.resultCompleted, onChange: (evt, newVal) => props.setMatchState({ resultCompleted: newVal }), name: "checkedB", color: "primary" }), label: "Indberetning af resultat for denne kamp er afsluttet", className: "printHide" }),
            props.publishPlayerRosterNow !== undefined &&
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: props.matchData.teamsPublic, onChange: (evt, newVal) => props.setMatchState({ teamsPublic: newVal }), name: "checkedB", color: "primary" }), label: "Offentligg\u00F8r holdopstillinger nu", className: "printHide" }),
            props.liveScore !== undefined &&
                React.createElement(TextField, { id: "multiline-static", label: "Kode til Live Score (valgfri)", onChange: (evt) => props.setMatchState({ liveScoreCode: evt.target.value }), defaultValue: liveScoreCode, variant: "outlined" }),
            props.remarks !== undefined &&
                React.createElement(TextField, { id: "outlined-multiline-static", label: "Bem\u00E6rkninger", multiline: true, rows: 3, onChange: (evt) => props.setMatchState({ comment: evt.target.value }), defaultValue: props.matchData.comment, variant: "outlined", className: "printHide" }),
            props.combinedResultsForTeams !== undefined &&
                React.createElement(Grid, { container: true, alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement(TextField, { label: props.matchData.teamName1, type: "number", onChange: (evt) => props.setMatchState({ score1: evt.target.value }), defaultValue: props.matchData.score1, InputLabelProps: {
                                shrink: true,
                            }, variant: "outlined", error: getError('Match.Score1'), helperText: getError('Match.Score1') ? getError('Match.Score1') : '' })),
                    React.createElement(Grid, { item: true },
                        React.createElement(TextField, { label: props.matchData.teamName2, type: "number", onChange: (evt) => props.setMatchState({ score2: evt.target.value }), defaultValue: props.matchData.score2, InputLabelProps: {
                                shrink: true,
                            }, variant: "outlined", error: getError('Match.Score2'), helperText: getError('Match.Score2') ? getError('Match.Score2') : '' })),
                    React.createElement(Grid, { item: true, className: classes.WalkOver },
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: props.matchData.walkOver, onChange: (evt, newVal) => props.setMatchState({ walkOver: newVal }), name: "checkedB", color: "primary" }), label: "Afgjort uden kamp (afbud / udeblivelse)", className: "printHide" }),
                        props.matchData.walkOver &&
                            React.createElement(RadioGroup, { row: true, "aria-label": "position", name: "position", value: props.matchData.walkOverReason.toString(), style: { marginLeft: -15, marginTop: -18 }, onChange: (evt, newVal) => props.setMatchState({ walkOverReason: newVal }) },
                                React.createElement(FormControlLabel, { value: "0", control: React.createElement(Radio, { color: "primary" }), label: "Afbud rettidigt", labelPlacement: "start" }),
                                React.createElement(FormControlLabel, { value: "1", control: React.createElement(Radio, { color: "primary" }), label: "Afbud for sent", labelPlacement: "start" }),
                                React.createElement(FormControlLabel, { value: "2", control: React.createElement(Radio, { color: "primary" }), label: "Udeblivelse", labelPlacement: "start" }))),
                    React.createElement(Grid, { item: true, className: "printOnly" }, ((props.matchData.score1 || props.matchData.score2) && !props.printBlank) && React.createElement("h5", null, "Resultatet er ikke gemt og kan \u00E6ndres"))))));
};
